var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Billing Accounts - Manage"}},[_c('BillingAccounts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }